import { render, staticRenderFns } from "./skeleton-column.vue?vue&type=template&id=7a9d1504&"
import script from "./skeleton-column.vue?vue&type=script&lang=js&"
export * from "./skeleton-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports